interface Props {
    value: number;
    isEditable: boolean;
    onValueChange: (val: number) => void;
    onDoubleClick: () => void;
    getLabel: (i: number) => void;
    onPlus: () => void;
    onMin: () => void;
    unit?: string;
    min: number;
    max: number;
}

export default function CustomizeNumberRange({
    isEditable,
    unit,
    getLabel,
    value,
    onDoubleClick,
    onMin,
    onPlus,
    min,
    max,
}: Props): JSX.Element {
    return (
        <div
            onDoubleClick={onDoubleClick}
            className={`flex flex-row rounded-md border-[1px] ${
                isEditable ? "bg-white" : "bg-gray-100 text-gray-400"
            } `}
        >
            <button
                onClick={() => (isEditable ? onMin() : null)}
                disabled={min === value}
                className={`flex w-10 items-center justify-center ${
                    isEditable
                        ? "bg-yellow-400 disabled:cursor-not-allowed disabled:bg-yellow-100 disabled:text-white"
                        : "bg-gray-200"
                } `}
            >
                -
            </button>
            <div className="line my-1 flex w-full min-w-24 select-none flex-col items-center justify-center gap-0 ">
                <div className="text-xs leading-none">{getLabel ? getLabel(value) : value}</div>
                {unit && <div className="text-xs leading-none">{value !== 1 ? `${unit}s` : unit}</div>}
            </div>
            <button
                onClick={() => (isEditable ? onPlus() : null)}
                className={`flex w-10 items-center justify-center ${
                    isEditable
                        ? "bg-yellow-400 disabled:cursor-not-allowed disabled:bg-yellow-100 disabled:text-white"
                        : "bg-gray-200"
                } `}
                disabled={max === value}
            >
                +
            </button>
        </div>
    );
}
